<script>
export default {
  name: 'CockpitMatryoshkaPrintManuallyTab',
};
</script>

<template>
  <div class="is-placeholder">
    <p class="text-center p-5">
      PRACA MANUALNA ?
    </p>
  </div>
</template>

<style scoped lang="scss">

</style>
